// Lib
import { connect } from 'react-redux';
import { createSink } from 'recompose';
import { get } from 'lodash/fp';

// Utils
import { decodeParams } from '../../common/utils/urlUtil';

// Actions
import { handleSuccessfulAuthentication } from './authActions';
import { navigateToRootWorkspace } from '../reducers/navigationActions';

// Constants
import { APP_QUERY_PARAMS } from '../../common/utils/urlConstants';

const getToken = get([APP_QUERY_PARAMS.AUTH_TOKEN]);

export default (onSuccessActionFn) => {
    const mapDispatchToProps = (dispatch) => ({
        dispatchOnSuccess: (token, queryParams) =>
            dispatch((_dispatch, getState) => {
                onSuccessActionFn && dispatch(onSuccessActionFn(queryParams));

                // use replace so the token doesn't get into the browser history stack
                handleSuccessfulAuthentication({ replaceUrl: true, dispatch, getState })({ data: { token } });
            }),
        dispatchNavigateToRootWorkspace: () => dispatch(navigateToRootWorkspace(true)),
    });

    const ReferralRedirect = createSink(({ location, dispatchOnSuccess, dispatchNavigateToRootWorkspace }) => {
        const hashParams = decodeParams(location.hash);
        const queryParams = location.query;

        const token = getToken(hashParams) || getToken(queryParams);

        return token ? dispatchOnSuccess(token, queryParams) : dispatchNavigateToRootWorkspace();
    });

    return connect(null, mapDispatchToProps)(ReferralRedirect);
};
